<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>My Information</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>

            <v-tabs
                v-model="tab"
                fixed-tabs
            >
                <v-tab key="1">
                    My Information
                </v-tab>
                <v-tab key="2" @click="getLists">
                    Documents
                </v-tab>
                <v-tab key="3" @click="getLists">
                    HR
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                
                <!-- MY INFORMATION -->
                <v-tab-item key="1">
                    <br />
                    <v-row>
                        <v-col cols="6">
                            
                            <v-radio-group 
                                row 
                                v-model="userLoggedGetters.themeColor" 
                                @change="changeTheme()"
                                style="width: 100%"
                            >
                                <v-radio label="Dark"  :value="1" color="var(--color__main)"></v-radio>
                                <v-radio label="Light" :value="2" color="var(--color__main)"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12"
                            lg="6"
                            md="12"
                            sm="12"
                        >
                            <label>First Name</label>
                            <v-text-field
                                v-model="userLoggedGetters.firstName" 
                                :rules=[validations.required]
                                single-line
                                disabled
                                outlined
                                dense
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12"
                            lg="6"
                            md="12"
                            sm="12"
                        >
                            <label>Last Name</label>
                            <v-text-field
                                v-model="userLoggedGetters.lastName" 
                                single-line
                                disabled
                                outlined
                                dense
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12"
                            lg="6"
                            md="12"
                            sm="12"
                        >
                            <label>E-Mail</label>
                            <v-text-field
                                v-model="userLoggedGetters.email"
                                single-line
                                disabled
                                outlined
                                dense
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12"
                            lg="6"
                            md="12"
                            sm="12"
                        >
                            <label>State</label>
                            <v-combobox
                                v-model="userLoggedGetters.stateSelected"
                                :items="listState"
                                item-text="codeDescription"
                                item-value="id"
                                :rules=[validations.required]
                                clearable
                                single-line
                                outlined
                                dense
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12"
                            lg="6"
                            md="12"
                            sm="12"
                        >
                            <label>City</label>
                            <v-text-field
                                v-model="userLoggedGetters.city" 
                                :rules=[validations.required]
                                single-line
                                outlined
                                dense
                            >
                            </v-text-field>
                        </v-col>
                        
                        <v-col cols="12"
                            lg="6"
                            md="12"
                            sm="12"
                        >
                            <label>Address</label>
                            <v-text-field
                                v-model="userLoggedGetters.address" 
                                :rules=[validations.required]
                                single-line
                                outlined
                                dense
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                        
                </v-tab-item>

                <!-- DOCUMENTS -->
                <v-tab-item key="2">
                    <br />
                    
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <ContentHeader :description="'Employee Safety'" />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col 
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2 v-btn-big"
                                outlined
                                @click="showDialogPpe"
                            >
                                PPE Request
                            </v-btn>
                        </v-col>
                        <v-col 
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2 v-btn-big"
                                outlined
                                @click="showDialogVehicle"
                            >
                                Vehicle Repair Request
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-tab-item>

                <!-- HR -->
                <v-tab-item key="3">
                    <br />
                    
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <ContentHeader :description="'Employee Benefits'" />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col 
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2 v-btn-big"
                                outlined
                                @click="getAndDownload(1, TYPE_DOCUMENT.EMPLOYEE_BENEFITS_BOOKLET);"
                            >
                                {{ TYPE_DOCUMENT.EMPLOYEE_BENEFITS_BOOKLET.description }}
                            </v-btn>
                        </v-col>
                        <v-col 
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2 v-btn-big"
                                outlined
                                @click="getAndDownload(1, TYPE_DOCUMENT.STATUS_CHANGE_REQUESTS);"
                            >
                                {{ TYPE_DOCUMENT.STATUS_CHANGE_REQUESTS.description }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <ContentHeader :description="'Employee forms'" />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col 
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2 v-btn-big"
                                outlined
                                @click="showDialogVacation"
                            >
                                Vacation / Personal Leave Request
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-tab-item>

            </v-tabs-items>

            <br />

            <ActionButtons
                v-if="tab == 0"
                :request="userLoggedGetters"
                :showButtons="{
                    cancel: false,
                    save: true
                }"
                @save="saveProfile"
            />
        </v-form>

        <!-- VACATION REQUEST -->
        <v-dialog
            v-model="showVacation"
            transition="dialog-top-transition"
            width="1100"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                    Vacation / Personal Leave Request
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            style="text-align: right;"
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2"
                                outlined
                                @click="newVacationRequest"
                            >
                                New Request
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-data-table
                                :headers="headersVacation"
                                :items="listVacation"
                                :options.sync="options"
                                :loading="loading"
                                :items-per-page="10"
                                no-data-text="No Record Found"
                            >
                                <template v-slot:item.statusDescription="{ item }">
                                    <v-chip
                                        :color="getStatusColor(item.status)"
                                        outlined
                                        dark
                                    >
                                        {{ item.statusDescription }}
                                    </v-chip>
                                </template>
                                
                                <template v-slot:item.action="{item}">
                                    <ActionList 
                                        :id="item.id" 
                                        :showButtons="{
                                            edit: item.status === 0,
                                            sendApprove: item.status === 0,
                                            cancel2: item.status === 0 ? true : false,
                                            active: item.status === 99 ? true : false,
                                            download: true
                                        }"
                                        @confirmSendApprove="confirmSendApprove"
                                        @confirmCancel2="confirmCancelVacation"
                                        @confirmActive="confirmActiveVacation"
                                        @confirmDownload="confirmDownload"
                                    />
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-divider></v-divider>

				<v-card-actions style="padding: 15px !important;">
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonDismiss"
							outlined
							@click="showVacation = false"
						>
							Dismiss
						</v-btn>
					</div>
				</v-card-actions>

            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showVacationRequest"
            transition="dialog-top-transition"
            width="1200"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-form
                ref="formVacation"
                v-model="validFormVacation"
                lazy-validation
            >
                <v-card>
                    <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                        Form Request
                    </v-card-title>

                    <v-card-text style="margin-top: 20px;">
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Employee Name </label>
                                <v-text-field
                                    v-model="vacationRequest.userName" 
                                    single-line
                                    outlined
                                    dense
                                    disabled
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="2"
                                md="2"
                                sm="12"
                            >
                                <v-radio-group 
                                    v-model="vacationRequest.timeType"
                                    columns
                                    dense
                                    :rules=[validations.required]
                                    style="margin-top: -5px;"
                                >
                                    <v-radio
                                        label="Full time"
                                        :value="1"
                                        color="var(--color__main)"
                                    ></v-radio>
                                    <v-radio
                                        label="Part time"
                                        :value="2"
                                        color="var(--color__main)"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <v-menu
                                    ref="mnuStartDate"
                                    v-model="mnuStartDate"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <label>Leave to Start</label>
                                        <v-text-field
                                            v-model="startDateFormatted"
                                            prepend-inner-icon="mdi-calendar"
                                            v-bind="attrs"
                                            :rules=[validations.required]
                                            @blur="startDate = parseDate(startDateFormatted)"
                                            readonly
                                            outlined
                                            single-line
                                            v-on="on"
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="startDate"
                                        no-title
                                        @input="mnuStartDate = false"
                                        :min="today"
                                        color="primary lighten-1"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <v-menu
                                    ref="mnuEndDate"
                                    v-model="mnuEndDate"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <label>Expect to Return</label>
                                        <v-text-field
                                            v-model="endDateFormatted"
                                            prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                            :rules=[validations.required]
                                            @blur="endDate = parseDate(endDateFormatted)"
                                            readonly
                                            outlined
                                            single-line
                                            v-on="on"
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="endDate"
                                        no-title
                                        @input="mnuEndDate = false"
                                        :min="startDate"
                                        color="primary lighten-1"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col 
                                cols="12"
                                lg="4"
                                md="4"
                                sm="12"
                            >                            
                                <label>Type</label>
                                <v-combobox
                                    v-model="vacationRequest.typeVacationSelected"
                                    :items="listTypeVacation"
                                    item-text="description"
                                    item-value="id"
                                    :rules=[validations.required]
                                    single-line
                                    outlined
                                    dense
                                ></v-combobox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="2"
                                md="2"
                                sm="12"
                            >
                                <label>Time off Selection</label>
                                <div style="margin-top: 5px;">
                                    <v-checkbox
                                        v-model="vacationRequest.typeLeave"
                                        label="Paid Leave"
                                        :value="1"
                                        color="var(--color__main)"
                                        dense
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="vacationRequest.typeLeave"
                                        label="Unpaid Leave"
                                        :value="2"
                                        color="var(--color__main)"
                                        dense
                                        hide-details
                                    ></v-checkbox>
                                </div>
                            </v-col>

                            <v-col 
                                v-if="vacationRequest.typeLeave && vacationRequest.typeLeave.includes(1)"
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Days Allocated - Paid Leave</label>
                                <v-text-field
                                    v-model="vacationRequest.daysAllocatedPaid"
                                    type="number"
                                    min="0"
                                    single-line
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col 
                                v-if="vacationRequest.typeLeave && vacationRequest.typeLeave.includes(2)"
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Days Allocated - Unpaid Leave</label>
                                <v-text-field
                                    v-model="vacationRequest.daysAllocatedUnpaid"
                                    type="number"
                                    min="0"
                                    single-line
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Explanation</label>
								<v-textarea
									v-model="vacationRequest.description"
									:rules=[validations.required]
									single-line
									rows="3"
									row-height="30"
									outlined
								>
								</v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label style="font-style: italic;">Provisions of Leave: I understand that if do not return to work on the above date, or contact my supervisor regarding my failure to failure. I will be considered to have voluntarily abandoned my job.</label>
                            </v-col>
                        </v-row> 
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions style="padding: 15px !important;">
                        <div style="width: 100%; text-align: center;">
                            <v-btn
                                class="mx-2 dialogButtonCancel v-btn-large"
                                outlined
                                @click="showVacationRequest = false"
                            >
                                Cancel
                            </v-btn>

                            <v-btn
                                class="mx-2 v-btn-large"
                                outlined
                                @click="confirmVacationRequest"
                            >
                                Confirm
                            </v-btn>
                        </div>
                    </v-card-actions>

                </v-card>
            </v-form>
        </v-dialog>
        

        <!-- PPE REQUEST -->
        <v-dialog
            v-model="showPpe"
            transition="dialog-top-transition"
            width="1100"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                    PPE Request
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            style="text-align: right;"
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2"
                                outlined
                                @click="newPpeRequest"
                            >
                                New Request
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-data-table
                                :headers="headersPpe"
                                :items="listPpe"
                                :options.sync="options"
                                :loading="loading"
                                :items-per-page="10"
                                no-data-text="No Record Found"
                            >
                                <template v-slot:item.statusDescription="{ item }">
                                    <v-chip
                                        :color="getStatusColor(item.status)"
                                        outlined
                                        dark
                                    >
                                        {{ item.statusDescription }}
                                    </v-chip>
                                </template>
                                
                                <template v-slot:item.action="{item}">
                                    <ActionList 
                                        :id="item.id" 
                                        :showButtons="{
                                            edit: item.status === 0,
                                            sendApprove: item.status === 0,
                                            cancel2: item.status === 0 ? true : false,
                                            active: item.status === 99 ? true : false,
                                            download: true
                                        }"
                                        @customActionEdit="getPpe"
                                        @confirmSendApprove="confirmSendApprovePpe"
                                        @confirmCancel2="confirmCancelPpe"
                                        @confirmActive="confirmActivePpe"
                                        @confirmDownload="confirmDownloadPpe"
                                    />
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-divider></v-divider>

				<v-card-actions style="padding: 15px !important;">
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonDismiss"
							outlined
							@click="showPpe = false"
						>
							Dismiss
						</v-btn>
					</div>
				</v-card-actions>

            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showPpeRequest"
            transition="dialog-top-transition"
            width="1200"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-form
                ref="formPpe"
                v-model="validFormPpe"
                lazy-validation
            >
                <v-card>
                    <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                        PPE Request
                    </v-card-title>

                    <v-card-text style="margin-top: 20px;">
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Employee Name </label>
                                <v-text-field
                                    v-model="ppeRequest.userName" 
                                    single-line
                                    outlined
                                    dense
                                    disabled
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>PPE Needed</label>
								<v-textarea
									v-model="ppeRequest.description"
									:rules=[validations.required]
									single-line
									rows="3"
									row-height="30"
									outlined
								>
								</v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <div style="font-style: italic;">
                                    <strong>Terms and conditions</strong> <br/> <br/>

                                    By submitting this request, you acknowledge you are requesting Personal Protective Equipment (PPE) to safely perform your job duties. 
                                    Please note the reason for your request (e.g., replacement, damaged, new role). <br/>

                                    All PPE remains company property. You agree to return any previously issued equipment before receiving new or replacement items. 
                                    Failure to do so may result in delays or replacement fees.
                                </div>
                                <v-switch
                                    v-model="ppeAgreement"
                                    label="I agree"
                                    color="var(--color__main)"
                                    :disabled="ppeRequest != null && ppeRequest.id != 0"
                                >
                                </v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions style="padding: 15px !important;">
                        <div style="width: 100%; text-align: center;">
                            <v-btn
                                class="mx-2 dialogButtonCancel v-btn-large"
                                outlined
                                @click="showPpeRequest = false"
                            >
                                Cancel
                            </v-btn>

                            <v-btn
                                class="mx-2 v-btn-large"
                                outlined
                                @click="confirmPpeRequest"
                            >
                                Confirm
                            </v-btn>
                        </div>
                    </v-card-actions>

                </v-card>
            </v-form>
        </v-dialog>
        

        <!-- VEHICLE REPAIR REQUEST -->
        <v-dialog
            v-model="showVehicle"
            transition="dialog-top-transition"
            width="1100"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                    Vehicle Repair Request
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            style="text-align: right;"
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-btn
                                class="mx-2"
                                outlined
                                @click="newVehicleRequest"
                            >
                                New Request
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-data-table
                                :headers="headersVehicle"
                                :items="listVehicle"
                                :options.sync="options"
                                :loading="loading"
                                :items-per-page="10"
                                no-data-text="No Record Found"
                            >
                                <template v-slot:item.statusDescription="{ item }">
                                    <v-chip
                                        :color="getStatusColor(item.status)"
                                        outlined
                                        dark
                                    >
                                        {{ item.statusDescription }}
                                    </v-chip>
                                </template>
                                
                                <template v-slot:item.action="{item}">
                                    <ActionList 
                                        :id="item.id" 
                                        :showButtons="{
                                            edit: item.status === 0,
                                            sendApprove: item.status === 0,
                                            cancel2: item.status === 0 ? true : false,
                                            active: item.status === 99 ? true : false,
                                            download: true
                                        }"
                                        @customActionEdit="getVehicle"
                                        @confirmSendApprove="confirmSendApproveVehicle"
                                        @confirmCancel2="confirmCancelVehicle"
                                        @confirmActive="confirmActiveVehicle"
                                        @confirmDownload="confirmDownloadVehicle"
                                    />
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-divider></v-divider>

				<v-card-actions style="padding: 15px !important;">
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonDismiss"
							outlined
							@click="showVehicle = false"
						>
							Dismiss
						</v-btn>
					</div>
				</v-card-actions>

            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showVehicleRequest"
            transition="dialog-top-transition"
            width="1200"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-form
                ref="formVehicle"
                v-model="validFormVehicle"
                lazy-validation
            >
                <v-card>
                    <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                        Vehicle Repair Request
                    </v-card-title>

                    <v-card-text style="margin-top: 20px;">
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Employee Name </label>
                                <v-text-field
                                    v-model="vehicleRequest.userName" 
                                    single-line
                                    outlined
                                    dense
                                    disabled
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="6"
                                md="6"
                                sm="12"
                            >
                                <label>Driver Name</label>
                                <v-text-field
                                    v-model="vehicleRequest.driverName" 
									:rules=[validations.required]
                                    single-line
                                    outlined
                                    dense
                                >
                                </v-text-field>
                            </v-col>
                            <v-col 
                                cols="12"
                                lg="6"
                                md="6"
                                sm="12"
                            >
                                <label>Vehicle</label>
                                <v-text-field
                                    v-model="vehicleRequest.vehicle" 
									:rules=[validations.required]
                                    single-line
                                    outlined
                                    dense
                                >
                                </v-text-field>
                            </v-col>
                            <v-col 
                                cols="12"
                                lg="6"
                                md="6"
                                sm="12"
                            >
                                <label>Tag</label>
                                <v-text-field
                                    v-model="vehicleRequest.tag" 
									:rules=[validations.required]
                                    single-line
                                    outlined
                                    dense
                                >
                                </v-text-field>
                            </v-col>
                            <v-col 
                                cols="12"
                                lg="6"
                                md="6"
                                sm="12"
                            >
                                <label>Current Mileage</label>
                                <v-text-field
                                    v-model="vehicleRequest.currentMileage" 
									:rules=[validations.required]
                                    single-line
                                    outlined
                                    dense
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Repair Needed</label>
								<v-textarea
									v-model="vehicleRequest.description"
									:rules=[validations.required]
									single-line
									rows="3"
									row-height="30"
									outlined
								>
								</v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                            >
                                <canvas id="canvas" hidden></canvas>
                                <label>Photos of Vehicle</label>
                                <v-file-input
                                    v-model="vehicleFilesPhotos" 
                                    accept="image/*"
                                    small-chips
                                    multiple
                                    outlined
                                    placeholder="Click here to add"
                                    prepend-inner-icon="mdi-paperclip"
                                    prepend-icon=""
                                    @change="resizePreviewImage(vehicleFilesPhotos, vehiclePhotos)"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                v-for="(itemPhoto, index) in vehiclePhotos.filter(pht => pht.deleted == false)"
                                :key="index"
                                cols="12"
                                lg="2"
                                md="4"
                                sm="12"
                            >
                                <v-card max-width="200">
                                    <v-img
                                        :src="itemPhoto.src"
                                        :lazy-src="itemPhoto.src"
                                        aspect-ratio="1"
                                        max-height="200"
                                        max-width="200"
                                        style="cursor: pointer;"
                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileNameComplete)"
                                    >
                                        <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                        </template>
                                    </v-img>
                                    <span class="imageFileName">{{ itemPhoto.fileName }}</span>
                                    <v-icon class="deletePhotoIcon" small right color="var(--color__red)" @click="confirmPhotoDelete(itemPhoto)">mdi mdi-delete</v-icon>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <div style="font-style: italic;">
                                    <span style="color: var(--color__red); font-size: 15px">*** IF YOUR VEHICLE IS NOT SAFE TO DRIVE, REPORT IT IN PERSON IMMEDIATELY.</span> <br/><br/>

                                    <strong>Terms and conditions</strong> <br/> <br/>

                                    Your vehicle is your responsibility — it’s your “office” on wheels. Treat it with respect, because if your vehicle goes down, so do you. <br/> <br/>

                                    Use this form to report any repair or maintenance needs. To help prevent issues, check tire pressures, fuel level, and overall condition daily, 
                                    and keep your vehicle clean and road-ready. <br/> <br/>

                                    All vehicles remain company property and must be properly maintained.
                                </div>
                                <v-switch
                                    v-model="vehicleAgreement"
                                    label="I agree"
                                    color="var(--color__main)"
                                    :disabled="vehicleRequest != null && vehicleRequest.id != 0"
                                >
                                </v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions style="padding: 15px !important;">
                        <div style="width: 100%; text-align: center;">
                            <v-btn
                                class="mx-2 dialogButtonCancel v-btn-large"
                                outlined
                                @click="showVehicleRequest = false"
                            >
                                Cancel
                            </v-btn>

                            <v-btn
                                class="mx-2 v-btn-large"
                                outlined
                                @click="confirmVehicleRequest"
                            >
                                Confirm
                            </v-btn>
                        </div>
                    </v-card-actions>

                </v-card>
            </v-form>
        </v-dialog>
        
        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import ActionButtons from "@/components/Layout/ActionButtons";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import ActionList from "@/components/Layout/ActionList";
    import ContentHeader from "@/components/Layout/ContentHeader.vue";
    import { 
        URL_ATTACHMENT,
        URL_VACATION_REQUEST_PDF,
        URL_PPE_REQUEST_PDF,
        URL_VEHICLE_REQUEST_PDF,
        TYPE_ATTACHMENT,
        TYPE_DOCUMENT
    } from "@/utilities/Enums";

    export default ({

        mixins: [Helpers],

        components: {
            ActionButtons,
            ActionDialog,
            ActionList,
            ContentHeader
        },

        data: vm => ({

            validForm: true,

            tab: null,

            listState: [],

            loading: false,

            //VACATION
            showVacation: false,
            showVacationRequest: false,
            headersVacation: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Leave To Start", value: "startDateFormatted", sortable: true },
                { text: "Expect to Return", value: "endDateFormatted", sortable: true },
                { text: "Type", value: "typeVacationDescription", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],
            
            today: (new Date(Date.now() - ( new Date() ).getTimezoneOffset() * 60000) ).toISOString().substr(0, 10),
            startDate: vm.today,
            startDateFormatted: vm.formatDate(vm.today),
            mnuStartDate: false,

            endDate: vm.today,
            endDateFormatted: vm.formatDate(vm.today),
            mnuEndDate: false,

            actualDate: vm.today,
            actualDateFormatted: vm.formatDate(vm.today),
            mnuActualDate: false,

            validFormVacation: true,
            statusId: 0,
            listVacation: [],
            listTypeVacation: [],
            vacationRequest: {
                userName: "",
                timeType: 1, // full time
                typeLeave: [1], // paid leave
                typeSelected: { id: 1, description: "Vacation" },
                startDate: null,
                endDate: null,
                actualDate: null,
                type: 1, // vacation
                description: "",
                daysAllocatedPaid: null,
                daysAllocatedUnpaid: null
            },
            listVacationType: [],

            //PPE            
            showPpe: false,
            showPpeRequest: false,
            headersPpe: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "PPE Needed", value: "description", sortable: true },
                { text: "Approved On", value: "dateApproveOrDenyFormatted", sortable: true },
                { text: "Approved By", value: "userNameApproveOrDeny", sortable: true },
                { text: "Reason", value: "reason", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            listPpe: [],
            validFormPpe: true,
            ppeAgreement: false,
            ppeRequest: {
                userName: "",
                description: ""
            },

            //Vehicle            
            showVehicle: false,
            showVehicleRequest: false,
            headersVehicle: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Driver Name", value: "driverName", sortable: true },
                { text: "Vehicle", value: "vehicle", sortable: true },
                { text: "Approved On", value: "dateApproveOrDenyFormatted", sortable: true },
                { text: "Approved By", value: "userNameApproveOrDeny", sortable: true },
                { text: "Reason", value: "reason", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            listVehicle: [],
            validFormVehicle: true,
            vehicleAgreement: false,
            vehicleRequest: {
                userName: "",
                driverName: "",
                vehicle: "",
                tag: "",
                currentMileage: "",
                description: ""
            },

            vehicleFilesPhotos: [],
            vehiclePhotos: [],

            options: { rowsPerPage: 10, page: 1 },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            validations: {
                required,
            },

            URL_ATTACHMENT,
            URL_VACATION_REQUEST_PDF,
            URL_PPE_REQUEST_PDF,
            URL_VEHICLE_REQUEST_PDF,
            TYPE_ATTACHMENT,
            TYPE_DOCUMENT
        }),

        props: {
            params: {
                default: ""
            }
        },

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),
        },

        watch: {

            startDate () {
                this.startDateFormatted = this.formatDate(this.startDate)
            },

            endDate () {
                this.endDateFormatted = this.formatDate(this.endDate)
            },

            actualDate () {
                this.actualDateFormatted = this.formatDate(this.actualDate)
            },
        },

        methods: {

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    //DRAFT
                    case 0:
                        color = 'var(--color__silver)';
                        break;

                    //PENDING
                    case 1:
                        color = 'var(--color__status_pending)';
                        break;

                    //APPROVED
                    case 2:
                        color = 'var(--color__main)';
                        break;

                    //DENIED or CANCELLED
                    case 3:
                    case 99:
                        color = 'var(--color__red)';
                        break;
                
                    default:
                        break;
                }

                return color
            },

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

            async getLists() {
                
                this.listState = await this.$store.dispatch("stateModule/List");
                this.listTypeVacation = await this.$store.dispatch("vacationModule/ListTypeVacation");
                this.listVacation = await this.$store.dispatch("vacationModule/ListByUser", this.userLoggedGetters.id);
                this.listPpe = await this.$store.dispatch("ppeModule/ListByUser", this.userLoggedGetters.id);
                this.listVehicle = await this.$store.dispatch("vehicleModule/ListByUser", this.userLoggedGetters.id);
            },

            changeTheme() {
                
                if (this.userLoggedGetters.themeColor === 1)  { 
                    //dark
                    this.$vuetify.theme.dark = true;
                }
                else { 
                    // light
                    this.$vuetify.theme.dark = false;
                }
            },

            async saveProfile() {

                await this.$refs.form.validate();

                if (this.validForm === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                    return false;
                }
                else {

                    this.loading = true;
                    this.showLoading();

                    const requestProfile = {
                        idUser: this.userLoggedGetters.id, 
                        stateID: this.userLoggedGetters.stateSelected.id,
                        city: this.userLoggedGetters.city,
                        address: this.userLoggedGetters.address,
                        themeColor: this.userLoggedGetters.themeColor
                    }

                    const result = await this.$store.dispatch("userModule/UpdateProfile", requestProfile);

                    if (result.success === true) {
                        this.showToast("success", "Success!", result.message);
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                    }

                    this.loading = false;
                    this.hideLoading();
                }
            },

            //VACATION
            async showDialogVacation() {
                this.showVacation = true;
            },

            async newVacationRequest() {
                this.vacationRequest = {
                    id: 0,
                    userName: this.userLoggedGetters.lastName + ", " + this.userLoggedGetters.firstName,
                    timeType: 1, // full time
                    typeLeave: [1], // paid leave
                    startDate: this.today,
                    endDate: this.today,
                    actualDate: this.today,
                    typeSelected: this.listTypeVacation[0],
                    description: null,
                    daysAllocatedPaid: null,
                    daysAllocatedUnpaid: null
                };

                this.showVacationRequest = true;
            },
            
            async getVacation(id) {

                if (id !== 0) {

                    const response = await this.$store.dispatch("vacationModule/GetById", id);

                    if (response.success) {
                        this.vacationRequest = response.result;
                        const typeLeaveValue = response.result.typeLeave;
                        const typeLeaveArray = [];
                        if (typeLeaveValue & 1) typeLeaveArray.push(1);
                        if (typeLeaveValue & 2) typeLeaveArray.push(2);
                        this.vacationRequest.typeLeave = typeLeaveArray.length > 0 ? typeLeaveArray : [1];
                        this.vacationRequest.daysAllocatedPaid = response.result.daysAllocatedPaid ?? null;
                        this.vacationRequest.daysAllocatedUnpaid = response.result.daysAllocatedUnpaid ?? null;
                        
                        this.showVacationRequest = true;
                    }
                }
            },

            async confirmVacationRequest() {

                await this.$refs.formVacation.validate();

                if (this.validFormVacation === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the vacation form. Please review!");
                    return false;
                }
                else {
                    this.dialog = {
                        show: true,
                        headerText: 'Confirmation',
                        bodyText: 'You will send a new request vacation / leave personal request to approve, confirm your decision?',
                        methodConfirm: this.sendVacationRequest,
                        params: 0
                    };
                }
            },

            confirmSendApprove(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will SEND this request to approve, confirm your decision?',
                    methodConfirm: this.updateVacationStatus,
                    params: id
                };
            },

            confirmCancelVacation(id) {

                this.statusId = 99;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will CANCEL this request, confirm your decision?',
                    methodConfirm: this.updateVacationStatus,
                    params: id
                };
            },

            confirmActiveVacation(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this request again, confirm your decision?',
                    methodConfirm: this.updateVacationStatus,
                    params: id
                };

            },

            async updateVacationStatus(id) {

                this.showLoading();
                const vacationStatusRequest = {
                    id,
                    status: this.statusId
                };

                const result = await this.$store.dispatch("vacationModule/UpdateStatus", vacationStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getLists();

                this.hideLoading();
            },
            
            async sendVacationRequest() {
                
                this.showLoading();

                let typeVacation = 0;

                if (this.vacationRequest.typeVacationSelected != null && this.vacationRequest.typeVacationSelected != undefined) {
                    typeVacation = this.vacationRequest.typeVacationSelected.id;
                }

                const request = {
                    id: this.vacationRequest.id,
                    idUser: this.userLoggedGetters.id,
                    typeTime: this.vacationRequest.timeType,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    typeVacation,
                    typeLeave: Array.isArray(this.vacationRequest.typeLeave)
                        ? this.vacationRequest.typeLeave.reduce((acc, val) => acc | val, 0)
                        : (this.vacationRequest.typeLeave ?? 1),
                    daysAllocatedPaid: this.vacationRequest.daysAllocatedPaid ? parseInt(this.vacationRequest.daysAllocatedPaid) : null,
                    daysAllocatedUnpaid: this.vacationRequest.daysAllocatedUnpaid ? parseInt(this.vacationRequest.daysAllocatedUnpaid) : null,
                    description: this.vacationRequest.description,
                };

                const result = await this.$store.dispatch("vacationModule/CreateUpdate", request);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                    this.showVacationRequest = false;
                    await this.getLists();
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.hideLoading();
            },

            async confirmDownload(id) {
                this.downloadFile(URL_VACATION_REQUEST_PDF, id, 'application/pdf', 'Vacation-Personal Leave Request Form.pdf')
            },

            //PPE
            async showDialogPpe() {
                this.showPpe = true;
            },

            async newPpeRequest() {
                this.ppeRequest = {
                    id: 0,
                    userName: this.userLoggedGetters.lastName + ", " + this.userLoggedGetters.firstName,
                    description: null
                };

                this.ppeAgreement = false;
                this.showPpeRequest = true;
            },
            
            async getPpe(id) {

                if (id !== 0) {
                    
                    this.ppeAgreement = true;
                    const response = await this.$store.dispatch("ppeModule/GetById", id);

                    if (response.success) {
                        this.ppeRequest = response.result;
                        
                        this.showPpeRequest = true;
                    }
                }
            },

            async confirmPpeRequest() {

                await this.$refs.formPpe.validate();

                if (this.validFormPpe === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the ppe form. Please review!");
                    return false;
                }
                else {
                    if (this.ppeAgreement === false) {
                        this.showToast("error", "Warning!", "You must agree to the terms and conditions.");
                        return false;
                    }
                    else {
                        this.dialog = {
                            show: true,
                            headerText: 'Confirmation',
                            bodyText: 'Will you save a new PPE request, confirm your decision?',
                            methodConfirm: this.savePpeRequest,
                            params: 0
                        };
                    }
                }
            },

            confirmSendApprovePpe(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'Will you SUBMIT this request for approval, confirm your decision?',
                    methodConfirm: this.updatePpeStatus,
                    params: id
                };
            },

            confirmCancelPpe(id) {

                this.statusId = 99;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will CANCEL this request, confirm your decision?',
                    methodConfirm: this.updatePpeStatus,
                    params: id
                };
            },

            confirmActivePpe(id) {
                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this request again, confirm your decision?',
                    methodConfirm: this.updatePpeStatus,
                    params: id
                };
            },

            async updatePpeStatus(id) {

                this.showLoading();
                const ppeStatusRequest = {
                    id,
                    status: this.statusId
                };

                const result = await this.$store.dispatch("ppeModule/UpdateStatus", ppeStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getLists();

                this.hideLoading();
            },
            
            async savePpeRequest() {
                
                this.showLoading();

                const request = {
                    id: this.ppeRequest.id,
                    description: this.ppeRequest.description,
                };

                const result = await this.$store.dispatch("ppeModule/CreateUpdate", request);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                    this.showPpeRequest = false;
                    await this.getLists();
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.hideLoading();
            },

            async confirmDownloadPpe(id) {
                this.downloadFile(URL_PPE_REQUEST_PDF, id, 'application/pdf', 'PPE Request Form.pdf')
            },

            //VEHICLE
            async showDialogVehicle() {
                this.showVehicle = true;
            },

            async newVehicleRequest() {
                this.vehicleRequest = {
                    id: 0,
                    userName: this.userLoggedGetters.lastName + ", " + this.userLoggedGetters.firstName,
                    driverName: null,
                    vehicle: null,
                    tag: null,
                    currentMileage: null,
                    description: null
                };

                this.vehicleAgreement = false;
                this.vehicleFilesPhotos = [];
                this.vehiclePhotos = [];
                this.showVehicleRequest = true;
            },
            
            async getVehicle(id) {

                if (id !== 0) {

                    this.vehicleAgreement = true;

                    const response = await this.$store.dispatch("vehicleModule/GetById", id);

                    if (response.success) {
                        this.vehicleRequest = response.result;
                        
                        this.vehicleFilesPhotos = [];
                        this.vehiclePhotos = [];

                        const listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.HR.value, idKey: this.vehicleRequest.id });
                        const listPhotos = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.VEHICLE_PHOTOS.value);  
                        listPhotos.forEach(itemPhoto => {

                            this.vehiclePhotos.push({
                                id: itemPhoto.id,
                                file: new File([], itemPhoto.fileName),
                                type: itemPhoto.fileType,
                                fileName: itemPhoto.fileNameShort,
                                fileNameComplete: itemPhoto.fileName,
                                deleted: false,
                                src: `data:image/jpg;base64,${itemPhoto.file}`
                            })

                        })
                        
                        this.showVehicleRequest = true;
                    }
                }
            },
            
            async confirmPhotoDelete(itemPhotoToDelete) {

                this.itemPhotoToDelete = itemPhotoToDelete;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will DELETE this file [${itemPhotoToDelete.fileName}], confirm your decision?`,
                    methodConfirm: this.deletePhoto,
                    params: 0
                };
            },

            async deletePhoto() {

                this.itemPhotoToDelete.deleted = true;
            },            

            async uploadFiles(id, idKey, file, typeDocument, deleted = false, idKeyReference = 0) {

                const attachmentRequest = {
                    id: id,
                    idKey: idKey,
                    file: file ? file : new Blob(),
                    fileName: file ? file.name : "",
                    fileType: file ? file.type : "",
                    fileSize: file ? file.size : 0,
                    deleted: deleted ? deleted : false,
                    typeAttachment: TYPE_ATTACHMENT.HR.value,
                    typeDocument: typeDocument,
                    idKeyReference: idKeyReference
                }

                if (attachmentRequest.fileName != null && attachmentRequest.fileName != undefined) {
                    let attachmentFileRequest = new FormData();

                    attachmentFileRequest.append("attachmentRequest", JSON.stringify(attachmentRequest));
                    attachmentFileRequest.append("attachmentFile", attachmentRequest.file, attachmentRequest.fileName);

                    const result = await this.$store.dispatch("attachmentModule/CreateUpdate", { 
                        attachmentFileRequest, 
                        id: 0
                    });

                    return result;
                }
                else {
                    return {
                        success: true
                    };
                }
            },

            async savePhotos() {

                let allResult = []

                this.vehiclePhotos.forEach(async itemPhoto => {

                    let result = await this.uploadFiles(itemPhoto.id, this.vehicleRequest.id, itemPhoto.file, TYPE_DOCUMENT.VEHICLE_PHOTOS.value, itemPhoto.deleted, itemPhoto.idKeyReference ?? 0);

                    if (result.success == false) {
                        allResult.push({
                            typeDocument: TYPE_DOCUMENT.VEHICLE_PHOTOS.description,
                            message: result.message
                        })
                    }
                })

                if (allResult.length > 0) {
                    let message = ""

                    await allResult.forEach(itemResult => {
                        message += `Error to upload photos: [${itemResult.message}] \n`;
                    })

                    this.showToast("error", "Warning!", message);

                    return false;
                }
                else {
                    return true;
                }
            },

            async confirmVehicleRequest() {

                await this.$refs.formVehicle.validate();

                if (this.validFormVehicle === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the vehicle form. Please review!");
                    return false;
                }
                else {

                    if (this.vehicleAgreement === false) {
                        this.showToast("error", "Warning!", "You must agree to the terms and conditions.");
                        return false;
                    }
                    else {
                        this.dialog = {
                            show: true,
                            headerText: 'Confirmation',
                            bodyText: 'Will you save a new vehicle repair request, confirm your decision?',
                            methodConfirm: this.saveVehicleRequest,
                            params: 0
                        };
                    }
                }
            },

            confirmSendApproveVehicle(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'Will you SUBMIT this request for approval, confirm your decision?',
                    methodConfirm: this.updateVehicleStatus,
                    params: id
                };
            },

            confirmCancelVehicle(id) {

                this.statusId = 99;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will CANCEL this request, confirm your decision?',
                    methodConfirm: this.updateVehicleStatus,
                    params: id
                };
            },

            confirmActiveVehicle(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this request again, confirm your decision?',
                    methodConfirm: this.updateVehicleStatus,
                    params: id
                };

            },

            async updateVehicleStatus(id) {

                this.showLoading();
                const vehicleStatusRequest = {
                    id,
                    status: this.statusId
                };

                const result = await this.$store.dispatch("vehicleModule/UpdateStatus", vehicleStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getLists();

                this.hideLoading();
            },
            
            async saveVehicleRequest() {
                
                this.showLoading();

                const request = {
                    id: this.vehicleRequest.id,
                    driverName: this.vehicleRequest.driverName,
                    vehicle: this.vehicleRequest.vehicle,
                    tag: this.vehicleRequest.tag,
                    currentMileage: this.vehicleRequest.currentMileage,
                    description: this.vehicleRequest.description,
                };

                let listResults = [];
                const result = await this.$store.dispatch("vehicleModule/CreateUpdate", request);

                this.vehicleRequest.id = result.idVehicle;

                if (await this.savePhotos()) {

                    listResults.push(result);
                }

                if (listResults.length > 0 && listResults.filter(res => res.success == false).length == 0) {
                    this.showToast("success", "Success!", "Request saved successfully!");
                    this.showVehicleRequest = false;
                    await this.getLists();
                }
                else {
                    const listErrors = listResults.filter(res => res.success == false).map(res => res.message).join("<br />");
                    this.loading = false;
                    this.hideLoading();
                    this.showToast("error", "Warning!", `Error to save request: ${listErrors}`);
                }

                this.hideLoading();
            },

            async confirmDownloadVehicle(id) {
                this.downloadFile(URL_VEHICLE_REQUEST_PDF, id, 'application/pdf', 'Vehicle Repair Request Form.pdf')
            },
            
            async checkParams() {

                if (this.params != null && this.params != undefined && this.params != "" ) {
                    const jsonParams = JSON.parse(this.params);

                    if (jsonParams != null && jsonParams != undefined) {
                        if (jsonParams.vacation) {

                            this.tab = jsonParams.vacation.tab || 0;
                            this.showDialogVacation();
                        }
                        else if (jsonParams.ppe) {
                            this.tab = jsonParams.ppe.tab || 0;
                            this.showDialogPpe();
                        }
                        else if (jsonParams.vehicle) {
                            this.tab = jsonParams.vehicle.tab || 0;
                            this.showDialogVehicle();
                        }
                    }
                }
            },

            async getAndDownload(id, typeDocument) {
                this.showLoading();

                const listAttachments = await this.$store.dispatch("attachmentModule/GetAllByDocument", { 
                    typeAttachment: TYPE_ATTACHMENT.HR.value, 
                    typeDocument: typeDocument.value, 
                    idKey: id
                });

                if (listAttachments != null && listAttachments != undefined && listAttachments.length > 0) {
                    const attachment = listAttachments[listAttachments.length - 1];

                    if (attachment != null && attachment != undefined) {
                        this.downloadFile(URL_ATTACHMENT, attachment.id, attachment.fileType, attachment.fileName);
                    }
                }
                else {
                    this.showToast("warning", "Warning", "There is no file to download.");
                }

                this.hideLoading();
            }
        },

        async created() {
            this.showLoading();

            await this.getLists();
            await this.checkParams();

            this.hideLoading();
        }
    })
</script>



<style scoped>

    .imageFileName {
        font-size: 10px; 
        margin-left: 5px;
    }

</style>